import { forwardRef, useEffect, useRef, useState } from 'react';

import { Box } from '@chakra-ui/react';

import { StickyHeaderProps } from '@app/components/molecules/sticky-header';

export const StickyHeader = forwardRef<HTMLDivElement, StickyHeaderProps>(
    ({ children, scrollableRef, isOpen, shadowStyle = 'stickyHeader', ...boxProps }, ref) => {
        const anchorRef = useRef<HTMLDivElement>(null);
        const [isSticky, setIsSticky] = useState(false);

        useEffect(() => {
            if (!isOpen) return;

            let observer: IntersectionObserver | null = null;

            const timeoutId = setTimeout(() => {
                if (!anchorRef.current || !scrollableRef.current) {
                    return;
                }

                setIsSticky(false);

                observer = new IntersectionObserver(
                    ([entry]) => {
                        setIsSticky(!entry.isIntersecting);
                    },
                    {
                        root: scrollableRef.current,
                        threshold: 0,
                        rootMargin: '0px 0px -1px 0px',
                    },
                );

                observer.observe(anchorRef.current);
            }, 10);

            return () => {
                clearTimeout(timeoutId);
                if (observer) {
                    observer.disconnect();
                }
            };
        }, [isOpen, scrollableRef]);

        return (
            <>
                <Box ref={anchorRef} />
                <Box
                    ref={ref}
                    position={'sticky'}
                    top={-6}
                    bg={'white'}
                    zIndex={'sticky'}
                    boxShadow={isSticky ? shadowStyle : 'none'}
                    transition={'box-shadow 0.2s ease-in-out'}
                    {...boxProps}
                >
                    {children}
                </Box>
            </>
        );
    },
);

StickyHeader.displayName = 'StickyHeader';
